//to fix intl global is not defined
(window as any).global = window;
